/* eslint-disable consistent-return, default-param-last */

export function arrayToMap(array = [], key) {
    return array.reduce((map, entry, index) => {
        return {
            ...map,
            [entry[key] || index]: entry,
        };
    }, {});
}

export function arraysEqual(a, b) {
    if (a === b) {
        return true;
    }

    if (!a || !b || a.length !== b.length) {
        return false;
    }

    return range(a.length).every((i) => a[i] === b[i]);
}

export function convertToMillisecondsFromDecimalTime(hoursMinutes) {
    const [hours, minutes] = hoursMinutes.toString().split('.');
    const hoursInMilliseconds = hours * 60 * 60 * 1000;
    const minutesInMilliseconds = Math.ceil(parseFloat(`0.${minutes}`) * 60) * 60 * 1000;
    const totalMilliseconds = hoursInMilliseconds + minutesInMilliseconds;
    return totalMilliseconds;
}

export function createImageBannerTemplate(imagePath, titlePrefix, descriptionPrefix) {
    return range(2).reduce((arr, item, index) => {
        const translationIndex = index + 1;
        const src = `${imagePath}${translationIndex}.svg`;
        const title = `${titlePrefix}${translationIndex}`;
        const description = `${descriptionPrefix}${translationIndex}`;

        return [
            ...arr,
            {
                src,
                title,
                description,
            },
        ];
    }, []);
}

export function durationToHoursAndMinutes(momentDuration) {
    // TODO: better duck-typing of moment duration objects?
    if (!momentDuration || !momentDuration.hours) {
        return {};
    }

    return {
        hours: momentDuration.days() > 0
            ? momentDuration.hours()
            : momentDuration.hours() + (momentDuration.days() * 24),
        days: momentDuration.days(),
        minutes: momentDuration.minutes(),
    };
}

export function formatDuration(milliseconds) {
    const seconds = Math.floor((milliseconds / 1000) % 60);
    const minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
    const hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
    const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));

    const durationParts = {
        seconds: 0,
        minutes: 0,
        hours: 0,
        days: 0,
    };

    if (days > 0) {
        durationParts.days = days;
    }
    if (hours > 0) {
        durationParts.hours = hours;
    }
    if (minutes > 0) {
        durationParts.minutes = minutes;
    }
    if (seconds > 0) {
        durationParts.seconds = seconds;
    }

    return durationParts;
}

export function generateFakeOnChangeEvent(e = DEFAULT_EVENT, value) {
    return {
        ...e,
        currentTarget: {
            ...e.currentTarget,
            value,
        },
        target: {
            ...e.target,
            value,
        },
        type: 'onChange',
    };
}

export function getCookieByKey(key) {
    if (!key) {
        return;
    }

    if (key.substr(-1) !== '=') {
        // eslint-disable-next-line no-param-reassign
        key += '=';
    }

    const allCookies = document.cookie.split(/;\s*/);
    const cookie = allCookies.find((c) => c.startsWith(key));
    if (!cookie) {
        return;
    }

    const cookieValue = cookie.split(key)[1];
    return cookieValue;
}

const scripts = {};
export function getCountryFromLocale(locale = '') {
    if (!locale || !locale.includes('-')) {
        return;
    }

    const localeElements = locale.split('-');
    return localeElements[1];
}

export function indexedObjectToArray(obj) {
    return Object.keys(obj)
        .sort((k1, k2) => (parseInt(k1, 10) - parseInt(k2, 10)))
        .map((key) => {
            return obj[key];
        });
}

const DEFAULT_EVENT = {
    currentTarget: undefined,
    preventDefault() {},
    stopImmediatePropagation() {},
    stopPropagation() {},
    target: undefined,
};

export const isPromise = (obj) => obj && typeof obj.then === 'function';

/**
 * @param {Object} momentDuration
 * @return {Object} an object containing a day count, an hour count and a minute count
 */
export async function loadScript(url, cb) {
    let loadPromise = scripts[url];
    if (!loadPromise) {
        loadPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.async = true;
            script.addEventListener('load', resolve);
            script.addEventListener('error', reject);
            document.querySelector('head').appendChild(script);
        });
    }

    if (!cb) {
        return loadPromise;
    }

    try {
        await loadPromise;
        cb();
    } catch (ex) {
        cb(ex);
    }
}

export function omit(obj, blacklist) {
    return Object.entries(obj)
        .filter(([key]) => !blacklist.includes(key))
        .reduce((o, [key, value]) => ({ ...o, [key]: value }), {});
}

export function onNextFrame(fn) {
    setTimeout(() => {
        window.requestAnimationFrame(fn);
    }, 0);
}

/**
 * @description take an object with integer keys and turn it into an array  :|
 * @param {Object} obj
 * @return {Array<?>}
 */
export const range = (num) => [...Array(num).keys()];

/**
 * @description creates an array of image banner objects with image src path, title, and description
 * @param {Object} imagePath
 * @param {String} titlePrefix
 * @param {String} descriptionPrefix
 * @return {Array<?>}
 */
export function spreadAcross(arr, numCol) {
    const numRow = Math.floor(arr.length / numCol);
    let overflow = arr.length - (numCol * numRow);

    let startIndex = 0;
    return range(numCol).map((colIndex) => {
        let endIndex = startIndex + numRow;
        if (overflow > 0) {
            endIndex += 1;
            overflow -= 1;
        }

        const col = arr.slice(startIndex, endIndex);
        startIndex = endIndex;
        return col;
    });
}

export function transformTimeTo12HourFormat(timeString) {
    const [hours, minutes, seconds] = timeString.split(':');
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    const options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    };

    const formattedTime = date.toLocaleTimeString('en-US', options);
    return formattedTime;
}

export function userAgentIsLikelyABot(userAgent) {
    return /bot|googlebot|crawler|spider|robot|crawling/i.test(userAgent);
}
